export var SeastateContent;
(function (SeastateContent) {
    SeastateContent[SeastateContent["Calm"] = 0] = "Calm";
    SeastateContent[SeastateContent["VerySmooth"] = 1] = "VerySmooth";
    SeastateContent[SeastateContent["Smooth"] = 2] = "Smooth";
    SeastateContent[SeastateContent["Slight"] = 3] = "Slight";
    SeastateContent[SeastateContent["Moderate"] = 4] = "Moderate";
    SeastateContent[SeastateContent["RatherRough"] = 5] = "RatherRough";
    SeastateContent[SeastateContent["Rough"] = 6] = "Rough";
    SeastateContent[SeastateContent["High"] = 7] = "High";
    SeastateContent[SeastateContent["VeryHigh"] = 8] = "VeryHigh";
    SeastateContent[SeastateContent["Precipitous"] = 9] = "Precipitous";
})(SeastateContent || (SeastateContent = {}));
export const seastateContentOptions = [
    { value: SeastateContent.Calm, text: '0 - calm,  0m' },
    { value: SeastateContent.VerySmooth, text: '1 - very smooth, 0.1-0.1m' },
    { value: SeastateContent.Smooth, text: '2 - smooth, 0.2-1.0m' },
    { value: SeastateContent.Slight, text: '3 - slight, 1.0-1.5m' },
    { value: SeastateContent.Moderate, text: '4 - moderate, 1.5-2.5m' },
    { value: SeastateContent.RatherRough, text: '5 - rather rough, 2.5-4.0m' },
    { value: SeastateContent.Rough, text: '6 - rough, 4.0-5.5m' },
    { value: SeastateContent.High, text: '7 - high, 5.5-10m' },
    { value: SeastateContent.VeryHigh, text: '8 - very high, 10-12.5m' },
    { value: SeastateContent.Precipitous, text: '9 - precipitous > 12.5m' },
];
//# sourceMappingURL=SeastateContent.js.map